<template>
    <div>
        <a-skeleton :loading="loading" active >
            <a-list item-layout="horizontal" size="small" :data-source="data">
                <tower-card slot="renderItem" slot-scope="item" :tower="item"></tower-card>
            </a-list>
            <a-pagination :current="Number($route.params.page)" :total="followers" 
                :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
            />
        </a-skeleton>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '../../../plugins/axios'

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.params.page);
        next();
    },
    data: () => ({
        data: [],
        loading: false,
    }),
    
    computed: {
        ...mapState('$user', [
            'userid', 'followers',
        ]),
    },
    methods: {
        async load(page) {
            this.loading = true;
            const { data } = await axios.get("/backend/user/my.php", {
                params: {
                    id: this.userid, type: "follower", page
                }
            });
            this.loading = false;
            this.data = data.list;
        },
        change(page) {
            this.$router.push({ params: { page } });
        }
    }
}
</script>

<style>

</style>